import PendingIcon from "@mui/icons-material/Pending";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HelpIcon from "@mui/icons-material/Help";
import { Chip } from "@mui/material";

export const RagChip = ({
  color,
  label,
}: {
  color?: "red" | "orange" | "green";
  label: string;
}) => {
  if ("red" === color) {
    return (
      <Chip
        size="small"
        color="error"
        icon={<CancelIcon color="warning" />}
        label={label}
        variant="outlined"
      />
    );
  }

  if ("orange" === color) {
    return (
      <Chip
        size="small"
        color="warning"
        icon={<HelpIcon color="warning" />}
        label={label}
        variant="outlined"
      />
    );
  }

  if ("green" === color) {
    return (
      <Chip
        size="small"
        color="success"
        icon={<CheckCircleIcon color="warning" />}
        label={label}
        variant="outlined"
      />
    );
  }

  return (
    <Chip
      size="small"
      color="info"
      icon={<PendingIcon color="info" />}
      label={label}
      variant="outlined"
    />
  );
};

export const PendingChip = () => <RagChip label="Pending" />;
